import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  AddToWishlist,
  DeleteWishList,
} from "../Redux/Action/AddWishListAction";
import { useDispatch } from "react-redux";
import { addToCart, deletecart } from "../Redux/Action/cartAction";
import { ResetMovieDetail } from "../Redux/Action/MovieDetailAction";
import { actionTypes } from "../Redux/Reducer/MovieDetailReducer";

function UpcomingMovies(props) {
  const [wishlistLocal, setwishlistLocal] = useState([]);

  const dispatch = useDispatch();
  const history = useNavigate();

  useEffect(() => {
    if (props?.movieslist) {
      setwishlistLocal(props.movieslist);
    }
  }, [props.movieslist]);

  //------------------- Add To whishlist ----------------------

  const addToWishlist = (id) => {
    var getwishlist = JSON.parse(JSON.stringify(wishlistLocal));

    for (const key in getwishlist) {
      if (Object.hasOwnProperty.call(getwishlist, key)) {
        const element = getwishlist[key];
        if (element._id === id) {
          element.iswishlist = !element.iswishlist;
        }
      }
    }
    setwishlistLocal(getwishlist);
    const data = {
      movieID: id,
    };
    dispatch(AddToWishlist(data , history));
  };

  //------------------- Delete wishlist ----------------------

  const deletefromwishlist = (id) => {
    var getwishlist = JSON.parse(JSON.stringify(wishlistLocal));

    for (const key in getwishlist) {
      if (Object.hasOwnProperty.call(getwishlist, key)) {
        const element = getwishlist[key];
        if (element._id === id) {
          element.iswishlist = !element.iswishlist;
        }
      }
    }
    setwishlistLocal(getwishlist);
    dispatch(DeleteWishList(id , history));
  };

  //------------------- Add To Cart ----------------------

  const Addtocart = (id) => {
    var cartlist = JSON.parse(JSON.stringify(wishlistLocal));
    for (const key in cartlist) {
      if (Object.hasOwnProperty.call(cartlist, key)) {
        const element = cartlist[key];
        if (element._id === id) {
          element.iscart = !element.iscart;
        }
      }
    }
    setwishlistLocal(cartlist);
    const data = {
      movieID: id,
    };
    dispatch(addToCart(data , history));
  };

//------------------- Delete Cart ----------------------

  const deletefromcart = (id) => {
    var getcartlist = JSON.parse(JSON.stringify(wishlistLocal));
    for (const key in getcartlist) {
      if (Object.hasOwnProperty.call(getcartlist, key)) {
        const element = getcartlist[key];
        if (element._id === id) {
          element.iscart = !element.iscart;
        }
      }
    }
    setwishlistLocal(getcartlist);

    dispatch(deletecart({ type: "movie" }, id , history));
  };

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 5000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  return (
    <div className="main_container">
      <div className="upcoming rounded-[20px] mx-auto">
        <div className="flex justify-between items-center px-9 pb-5 pt-6">
          <p className="text-[#fff] text-[18px] sm:text-[32px] font-medium font-poppins">
            Upcoming Movies
          </p>
          <Link to="/all-movies?type=upcoming">
            <p className="text-[#fff] text-[14px] sm:text-[20px] font-medium font-poppins" onClick={() =>  dispatch(ResetMovieDetail(actionTypes.RESET_USER_MOVIE_LIST))}>
              View More
            </p>
          </Link>
        </div>
        <div className=" w-full pb-[24px] sm:pb-[50px]">
          {/* --------------------- All upcoming List ------------------------*/}

          <Carousel
            swipeable={true}
            // draggable={true} //
            //   showDots={true}
            responsive={responsive}
            ssr={true}
            infinite={true}
            arrows={true}
            autoPlaySpeed={500}
            keyBoardControl={true}
            // autoPlay={true}
            customTransition="all 1.5s"
            transitionDuration={500}
            // removeArrowOnDeviceType={["mobile"]}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            pauseOnHover={false}
            // shouldResetAutoplay={true}
          >
            {wishlistLocal ? (
              wishlistLocal?.map((e) => (
                <div
                  className="bg-[#161616] rounded-[10px] mx-auto pb-[23px] max-w-[240px] sm:max-w-[310px] xl:max-w-[350px] boxshadow relative"
                  key={e?._id}
                >
                  <Link to={`/movie-detail/${e?._id}`}>
                    <img
                      src={`${`https://hooc.b-cdn.net/${
                        e?.poster_image
                      }?t=${Date.now()}`}`}
                      alt="new"
                      className="w-[240px] sm:w-full h-[256px] sm:h-[330px] lg:h-[330px] xl:h-[373px] rounded-t-[10px]"
                      onClick={() => dispatch(ResetMovieDetail(actionTypes.RESET_MOVIE_DETAIL))}
                    ></img>
                  </Link>
                  <div
                    className="px-[5px] sm:px-1.5 min-h-[24px] sm:min-h-[30px] rounded-[50%] flex bg-[#fff] items-center absolute top-4 right-4 lg:top-9 lg:right-9 cursor-pointer"
                    onClick={() => {
                      if (e?.iswishlist) {
                        deletefromwishlist(e?._id);
                      } else {
                        if (localStorage.getItem("token")) {
                          addToWishlist(e?._id);
                        } else {
                          history("/login");
                        }
                      }
                    }}
                  >
                    <svg
                      fill={`${e.iswishlist ? "#076aff" : "transparent"}`}
                      stroke={`${!e.wishlist ? "#076aff" : "transparent"}`}
                      viewBox="0 0 24 22"
                      // width="18"
                      // height="16"
                      className=" w-[14px] h-[14px] sm:w-[18px] sm:h-[16px]"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 01-.686 0 16.709 16.709 0 01-.465-.252 31.147 31.147 0 01-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0114 20.408z"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="px-3 lg:px-5 pt-2.5" onClick={() => dispatch(ResetMovieDetail(actionTypes.RESET_MOVIE_DETAIL))}>
                    <Link to={`/movie-detail/${e?._id}`}>
                      <p className="text-[#fff] text-[14px] sm:text-[16px] truncate pb-2 font-medium font-poppins">
                    {e?.name}
                      </p>
                      <p className="text-[#fff] text-[12px] sm:text-[18px] font-medium font-poppins">
                        {e?.final_price?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 0,
                        })}
                          {e.discount_ && (
                      <span className="text-[#028F3B] ml-2 text-[10px] sm:text-[12px] font-medium font-poppins bg-[#d9eee2] px-3 py-1.5 rounded-[20px]">
                        {e.discount_}% off
                      </span>
                    )}
                      </p>
                    </Link>

                    <div className="flex justify-between items-center mt-4">
                      <Link to={`/movie-detail/${e?._id}`}>
                        <button className="bg-[#076AFF] px-[50px] sm:px-[60px] xl:px-[88px]  hover:transform transition-all duration-300 hover:-translate-y-[2px] hover:shadow-xl font-poppins font-medium rounded-[8px] min-h-[30px] sm:min-h-[40px] text-white text-[12px] sm:text-[14px]">
                          Buy Now
                        </button>
                      </Link>
                      <button
                        className="bg-[#142339] min-h-[30px] sm:min-h-[40px] px-3 lg:px-5  rounded-[8px]"
                        onClick={() => {
                          if (e?.iscart) {
                            deletefromcart(e._id);
                          } else {
                            if (localStorage.getItem("token")) {
                              Addtocart(e?._id);
                            } else {
                              history("/login");
                            }
                          }
                        }}
                      >
                        {!e?.iscart ? (
                          <>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 26 26"
                              fill="#076AFF"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.625 2.4375H4.2315L7.10369 14.6461C6.47731 14.6974 5.89514 14.9892 5.47929 15.4605C5.06344 15.9317 4.84623 16.5456 4.87325 17.1735C4.90026 17.8014 5.16938 18.3944 5.62417 18.8282C6.07895 19.2619 6.68404 19.5027 7.3125 19.5H21.125C21.3405 19.5 21.5472 19.4144 21.6995 19.262C21.8519 19.1097 21.9375 18.903 21.9375 18.6875C21.9375 18.472 21.8519 18.2653 21.6995 18.113C21.5472 17.9606 21.3405 17.875 21.125 17.875H7.3125C7.09701 17.875 6.89035 17.7894 6.73798 17.637C6.5856 17.4847 6.5 17.278 6.5 17.0625C6.5 16.847 6.5856 16.6403 6.73798 16.488C6.89035 16.3356 7.09701 16.25 7.3125 16.25H21.0291C21.5789 16.2514 22.1129 16.0663 22.5438 15.725C22.9747 15.3836 23.2772 14.9062 23.4016 14.3707L25.1233 7.05819C25.2075 6.70035 25.2096 6.32811 25.1296 5.96932C25.0496 5.61054 24.8894 5.2745 24.6612 4.98636C24.4329 4.69822 24.1424 4.46545 23.8114 4.30546C23.4805 4.14547 23.1176 4.06241 22.75 4.0625H6.28306L5.66638 1.43894C5.62442 1.26059 5.52341 1.10165 5.37975 0.987936C5.2361 0.874219 5.05822 0.812395 4.875 0.8125H1.625C1.40951 0.8125 1.20285 0.898103 1.05048 1.05048C0.898102 1.20285 0.8125 1.40951 0.8125 1.625C0.8125 1.84049 0.898102 2.04715 1.05048 2.19952C1.20285 2.3519 1.40951 2.4375 1.625 2.4375ZM22.75 5.6875C22.8718 5.68982 22.9915 5.71906 23.1006 5.77311C23.2098 5.82716 23.3056 5.90468 23.3812 6.00012C23.4569 6.09556 23.5104 6.20656 23.5381 6.32515C23.5658 6.44374 23.5669 6.56699 23.5414 6.68606L21.8189 13.9986C21.7778 14.1771 21.6772 14.3363 21.5337 14.4501C21.3902 14.5639 21.2123 14.6256 21.0291 14.625H8.7685L6.6625 5.6875H22.75ZM16.25 22.75C16.25 23.2321 16.393 23.7034 16.6608 24.1042C16.9286 24.505 17.3093 24.8175 17.7547 25.002C18.2001 25.1864 18.6902 25.2347 19.163 25.1407C19.6359 25.0466 20.0702 24.8145 20.4111 24.4736C20.752 24.1327 20.9841 23.6984 21.0782 23.2255C21.1722 22.7527 21.1239 22.2626 20.9395 21.8172C20.755 21.3718 20.4425 20.9911 20.0417 20.7233C19.6409 20.4555 19.1696 20.3125 18.6875 20.3125C18.041 20.3125 17.421 20.5693 16.9639 21.0264C16.5068 21.4835 16.25 22.1035 16.25 22.75ZM19.5 22.75C19.5 22.9107 19.4523 23.0678 19.3631 23.2014C19.2738 23.335 19.1469 23.4392 18.9984 23.5007C18.85 23.5621 18.6866 23.5782 18.529 23.5469C18.3714 23.5155 18.2266 23.4382 18.113 23.3245C17.9993 23.2109 17.922 23.0661 17.8906 22.9085C17.8593 22.7509 17.8754 22.5875 17.9368 22.4391C17.9983 22.2906 18.1025 22.1637 18.2361 22.0744C18.3697 21.9852 18.5268 21.9375 18.6875 21.9375C18.903 21.9375 19.1097 22.0231 19.262 22.1755C19.4144 22.3278 19.5 22.5345 19.5 22.75ZM7.3125 22.75C7.3125 23.2321 7.45546 23.7034 7.72329 24.1042C7.99113 24.505 8.37181 24.8175 8.81721 25.002C9.2626 25.1864 9.7527 25.2347 10.2255 25.1407C10.6984 25.0466 11.1327 24.8145 11.4736 24.4736C11.8145 24.1327 12.0466 23.6984 12.1407 23.2255C12.2347 22.7527 12.1864 22.2626 12.002 21.8172C11.8175 21.3718 11.505 20.9911 11.1042 20.7233C10.7034 20.4555 10.2321 20.3125 9.75 20.3125C9.10353 20.3125 8.48355 20.5693 8.02643 21.0264C7.56931 21.4835 7.3125 22.1035 7.3125 22.75ZM10.5625 22.75C10.5625 22.9107 10.5148 23.0678 10.4256 23.2014C10.3363 23.335 10.2094 23.4392 10.0609 23.5007C9.91247 23.5621 9.7491 23.5782 9.59149 23.5469C9.43388 23.5155 9.28911 23.4382 9.17548 23.3245C9.06185 23.2109 8.98446 23.0661 8.95311 22.9085C8.92176 22.7509 8.93785 22.5875 8.99935 22.4391C9.06084 22.2906 9.16498 22.1637 9.2986 22.0744C9.43221 21.9852 9.5893 21.9375 9.75 21.9375C9.96549 21.9375 10.1722 22.0231 10.3245 22.1755C10.4769 22.3278 10.5625 22.5345 10.5625 22.75Z"
                                fill="#076AFF"
                              />
                            </svg>
                          </>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xlink="http://www.w3.org/1999/xlink"
                            svgjs="http://svgjs.com/svgjs"
                            width="20"
                            height="20"
                            x="0"
                            y="0"
                            viewBox="0 0 24 24"
                            space="preserve"
                            className="group-hover:fill-white"
                          >
                            <g>
                              <path
                                d="M17.5 13c-3.584 0-6.5-2.916-6.5-6.5S13.916 0 17.5 0 24 2.916 24 6.5 21.084 13 17.5 13zm0-12C14.468 1 12 3.467 12 6.5s2.468 5.5 5.5 5.5S23 9.533 23 6.5 20.532 1 17.5 1z"
                                fill="#076aff"
                                data-original="#000000"
                                className="group-hover:fill-white"
                              ></path>
                              <path
                                d="M15.379 9.121a.5.5 0 0 1-.354-.853l4.242-4.242a.5.5 0 0 1 .707.707l-4.242 4.242a.498.498 0 0 1-.353.146z"
                                fill="#076aff"
                                data-original="#000000"
                                className="group-hover:fill-white"
                              ></path>
                              <path
                                d="M19.621 9.121a.502.502 0 0 1-.354-.146l-4.242-4.242a.5.5 0 0 1 .707-.707l4.242 4.242a.5.5 0 0 1-.353.853zM19.5 17h-13a.5.5 0 0 1-.49-.402l-2-10A.5.5 0 0 1 4.5 6h4a.5.5 0 0 1 0 1H5.11l1.8 9h12.18l.277-1.385a.5.5 0 0 1 .981.196l-.357 1.787A.502.502 0 0 1 19.5 17z"
                                fill="#076aff"
                                data-original="#000000"
                                className="group-hover:fill-white"
                              ></path>
                              <path
                                d="M6.499 17a.5.5 0 0 1-.489-.402L3.531 4.204A1.504 1.504 0 0 0 2.06 2.998h-.001L.501 3H.5a.5.5 0 0 1-.001-1l1.558-.002h.003c1.188 0 2.219.845 2.452 2.01L6.99 16.402a.498.498 0 0 1-.491.598z"
                                fill="#076aff"
                                data-original="#000000"
                                className="group-hover:fill-white"
                              ></path>
                              <path
                                d="M21.5 19h-17c-.827 0-1.5-.673-1.5-1.5S3.673 16 4.5 16h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 0 0 1h17a.5.5 0 0 1 0 1zM8 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zM17 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
                                fill="#076aff"
                                data-original="#000000"
                                className="group-hover:fill-white"
                              ></path>
                            </g>
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div></div>
            )}
          </Carousel>
        </div>
        {/* ---------------------End  of All upcoming List ------------------------*/}
      </div>
    </div>
  );
}

export default UpcomingMovies;
